import { render, staticRenderFns } from "./DetailTemp.vue?vue&type=template&id=5d31fc86&"
import script from "./DetailTemp.vue?vue&type=script&lang=js&"
export * from "./DetailTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports